export * from './Label.base';
export * from './Label.types';
export * from './Label';
//# sourceMappingURL=index.js.map